$(function(){
  // var target = $(".footer").offset().top - $(window).height()
  var resizefunction=function(){
      if($(window).width()>=1200){
      $(window).scroll(function () {
    var scrollTop = $(window).scrollTop()
     if($('.two-toaster-ver2__banner3-slide-wraper .caption').length>0){
    var capiton=$('.two-toaster-ver2__banner3-slide-wraper .caption').offset().top - $(window).height()
    if (scrollTop >= capiton) {
      $('.two-toaster-ver2__banner3-slide-wraper .caption').css({ 'opacity': '1', 'transform': 'translate(-50%,0)' })
      $('.two-toaster-ver2__banner3-slide-wraper .bottom_tag').css({ 'opacity': '1', 'transform': 'translate(-50%,0)' })
    } else if (scrollTop < capiton) {
      $('.two-toaster-ver2__banner3-slide-wraper .caption').css({ 'opacity': '0', 'transform': ' translate(-50%,100%)' })
      $('.two-toaster-ver2__banner3-slide-wraper .bottom_tag').css({ 'opacity': '0', 'transform': 'translate(-50%,100%)' })
    }
      }
    $(".left_text .title").each(function (index, item) {
        let target = $(item).offset().top - $(window).height()
        if (scrollTop >= target) {
          $(item).css({ 'opacity': '1', 'transform': 'translateY(0)' })
          $(item).siblings('.subtitle').css({ 'opacity': '1', 'transform': 'translateY(0)' })
        } else if (scrollTop < target) {
          $(item).css({ 'opacity': '0', 'transform': 'translateY(100%)' })
          $(item).siblings('.subtitle').css({ 'opacity': '0', 'transform': 'translateY(100%)' })
        }
      })
      $(".right_text .title_box").each(function (index, item) {
        let target = $(item).offset().top - $(window).height()
        if (scrollTop >= target) {
          $(item).css({ 'opacity': '1', 'transform': 'translateY(0)' })
        } else if (scrollTop < target) {
          $(item).css({ 'opacity': '0', 'transform': 'translateY(100%)' })
        }
      })
    })
  }
  }
  resizefunction()
  window.addEventListener("resize", resizefunction);
})